import store from '@/stores';

// acesso restrito ao perfil super (6)
const ALLOWED_ROLES = [6];

export default [
  {
    name: 'feature-access',
    path: '/liberacao-acesso',
    component: () => import('@/views/FeatureAccessGrant.vue'),
    beforeEnter: (to, from, next) => {
      const roles = store.state?.user?.userInfo?.roles_ids || [];
      if (roles.some((role) => ALLOWED_ROLES.includes(role))) next();
      else next({ path: '/' });
    },
  },
];
